import React from "react";
import { useSelector } from "react-redux";

import CoverSingleCard from "@/components/molecules/quote-section/quote-cover/cover-level-selection-card/cover-level-selection-card";
import {
  BenefitCopyDataType,
  CancellationCovers,
  CoverDrawerDetailsDataType,
} from "@/schema/quote-page/page.schema";
import { CoverContentTypeRenewal } from "@/schema/renewal-page/cover-level-page.schema";
import { RootState } from "@/store/root-reducer";

type MapQuoteCardProps = {
  closeDrawerCta?: string;
  benifitData?: BenefitCopyDataType[];
  coverDrawerCopy?: string;
  coverDrawerDetails?: CoverDrawerDetailsDataType[];
  coverDrawerTitle?: string;
  coverTitle?: string;
  coverType?: string;
  defaqtoRating?: 1 | 2 | 3 | 4 | 5;
  selectedCoverLevel?: string;
  selectedTab?: string;
  type?: number;
  updateCoverType?: boolean;
  setCancellationCoverOpen: (val: boolean) => void;
  setCancelltionChangeCoverType: (val: string) => void;
  setDynamicCoverLimit: (val: CancellationCovers[] | null) => void;
  updateSelectedCoverLevel: (
    val: string,
    state: boolean,
    index: number
  ) => void;
  isSocialProofChipActive?: boolean;
  chipTopText?: string;
  chipBottomText?: string;
  whichBestBuyBadge?: string;
} & CoverContentTypeRenewal;

function MapQuoteCard(props: Readonly<MapQuoteCardProps>) {
  const {
    benifitData,
    cancelationCoverBtnLabel,
    cancelationCoverCancelCta,
    cancelationCoverDescription,
    cancelationCoverTitle,
    cancelationCoverUpdateCta,
    closeDrawerCta = "Close",
    coverDrawerCopy = "",
    coverDrawerDetails,
    coverDrawerTitle = "",
    coverTitle,
    coverType,
    defaqtoRating,
    onlineExclusiveBannerLabel,
    seeMoreDetailsBtnLabel,
    selectBtnLabel,
    selectedCoverLevel,
    selectedTab,
    type,
    updateCoverType,
    setCancellationCoverOpen,
    setCancelltionChangeCoverType,
    setDynamicCoverLimit,
    updateSelectedCoverLevel,
    isSocialProofChipActive,
    chipTopText,
    chipBottomText,
    whichBestBuyBadge,
  } = props;

  const quoteData = useSelector((state: RootState) => state.quote);
  const { attributes } = quoteData;
  const { tripDetails } = attributes;

  return (
    <CoverSingleCard
      keyValue={coverType ?? ""}
      cardTopData={{
        cardTitle: coverTitle,
        selectBtnActiveLable: selectBtnLabel?.selectedLabel,
        selectBtnInactiveLable: selectBtnLabel?.notSelectedLabel,
        isLoading: updateCoverType && selectedCoverLevel === coverType,
      }}
      cardBottomData={{
        tableData: benifitData,
        changeBtnLabel: cancelationCoverBtnLabel,
        cancelationCoverTitle,
        cancelationCoverDescription,
        cancelationCoverUpdateCta,
        cancelationCoverCancelCta,
        seeMoreDetailsBtnLabel,
        drawerData: {
          drawerTitle: coverDrawerTitle,
          drawerCopy: coverDrawerCopy,
          drawerDetails: coverDrawerDetails ?? [],
          closeDrawerCta,
        },
        setCancellationCoverOpen,
        setDynamicCoverLimit,
        setCancelltionChangeCoverType,
        selectBtnActiveLable: selectBtnLabel?.selectedLabel,
        selectBtnInactiveLable: selectBtnLabel?.notSelectedLabel,
        isLoading: updateCoverType && selectedCoverLevel === coverType,
      }}
      onSelect={(val: string, state: boolean, index: number) =>
        updateSelectedCoverLevel(val, state, index)
      }
      isSelect={
        tripDetails?.initialQuotePageLoading !== true &&
        tripDetails?.policyPackage === coverType
      }
      type={selectedTab}
      defaqtoStarts={defaqtoRating ?? 3}
      whichBestBuyBadge={whichBestBuyBadge}
      onlineExclusiveBannerLabel={onlineExclusiveBannerLabel}
      id={type}
      isSocialProofChipActive={isSocialProofChipActive}
      chipTopText={chipTopText}
      chipBottomText={chipBottomText}
    />
  );
}

export default MapQuoteCard;
